// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CaseSearch_tableWrapper__Rqs-L"};